module.exports = __webpack_public_path__ + "OpenSans-LightItalic.04efde458ae3f9e9df8f.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-LightItalic.woff
// module id = ../../../../../src/assets/customfonts/OpenSans-LightItalic.woff
// module chunks = styles